import styled, {css} from 'styled-components';
import { primaryColor, infoColor, whiteColor } from './Variables';

export const BaseButton = css `
  width: 100%;
  padding: .5rem 1rem;
  border-radius: .4rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
`

export const Button = styled.button`
  ${BaseButton}
`

export const PrimaryButton = styled(Button)`
  border: 0;
  background-color: ${props => props.color ? props.color :  primaryColor};
  color: ${() =>  whiteColor};
`

export const OutlineWhiteButton = styled(Button)`
  border: 1px solid ${() => whiteColor};
  background-color: transparent;
  color: ${() => whiteColor};
`

export const InfoButton = styled(Button)`
  border: 0;
  background-color: ${() => infoColor};
  color: ${() => whiteColor};
  margin: ${props => props.margin};
  box-shadow: 0px 3px 6px #0000004d;
  &:hover {
    filter: brightness(90%);
  }
`

export const InfoButtonDisabled = styled(Button)`
  border: 0;
  background-color: #B2B2B2;
  color: ${() => whiteColor};
  margin: ${props => props.margin};
  box-shadow: 0px 3px 6px #0000004d;
  &:hover {
    filter: brightness(90%);
  }
`

export const OutlineInfoButton = styled(Button)`
  border: 1.5px solid ${() => infoColor};
  background-color: transparent;
  color: ${() => infoColor};
`

export const OutlineGrayButton = styled(Button)`
  border: 1px solid #B2B2B2;
  background-color: transparent;
  color: #B2B2B2;
  box-shadow: 0px 2px 4px #00000033;
  margin: ${props => props.margin};
  opacity: ${props => props.disableButton ? ".35" : "1"};
  cursor: ${props => props.disableButton ? "default" : "pointer"};
`
